// src/encounter/add-entry.tsx
//
// The ONE "add" entry of the note (19 Oct, Antonin: "Add note inlines exactly like the prototype's dashed Add clinical phrase";
// "make the add pattern one consistent pattern everywhere it appears in the note"). The prototype's `+ Insert clinical phrase`
// (`scrips-clinician-demo` `src/views/soh/encounter/PhraseNote.tsx`): a 32 px control, a dashed hairline, a plus and the label
// in the label role, secondary ink, the border and ink darken on hover. Look in `src/styles/showcase-bridge.css`
// (`/* soap page */`, hook `data-add-entry`); same DS Button, same handlers, same names.
//
// B10 (`visitNoteV2`; Antonin's list, 3 Nov: "no dashed lines anywhere … add buttons are quiet or secondary"): the DS `secondary`
// Button, solid, WITHOUT the `data-add-entry` hook, so the bridge's dashed rule no longer applies. Same label, plus and handler.
import type { ComponentProps } from 'react';
import { Button } from '@scripsteam/scrips-signal-ds';
import { Plus } from 'lucide-react';
import { useVisitNoteV2 } from './structured-note/label-parts-model';

export function AddEntryButton(props: Omit<ComponentProps<typeof Button>, 'variant' | 'size' | 'icon'>) {
  const noteV2 = useVisitNoteV2();
  if (noteV2) return <Button variant="secondary" size="sm" icon={<Plus className="size-4" aria-hidden />} {...props} />;
  return <Button variant="tertiary" size="sm" data-add-entry="" icon={<Plus className="size-4" aria-hidden />} {...props} />;
}
